import {
  HttpErrorResponse,
  HttpEvent,
  HttpHeaders,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import {
  MonoTypeOperatorFunction,
  catchError,
  from,
  retry,
  switchMap,
  throwError,
  timer,
} from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth-service/auth.service';
import { environment } from 'src/environments/environment';

const excludedUrls: string[] = [];
function retryStrategy<T extends HttpEvent<unknown>>(
  maxRetries: number,
  delayMs: number
): MonoTypeOperatorFunction<T> {
  return retry({
    count: maxRetries,
    delay: (error, retryCount) => {
      if (error instanceof HttpErrorResponse && error.status === 0) {
        console.warn(
          `Retrying API call (${retryCount}/${maxRetries}) due to network failure...`
        );
        return timer(delayMs);
      }
      console.error('API call failed after retries:', error);
      return throwError(() => error);
    },
  });
}

export const ApiInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const isCsApps = req.url.includes(environment.digitalApi);
  if (
    excludedUrls.includes(req.url) ||
    excludedUrls.some((el) => req.url.startsWith(el))
  ) {
    return next(req).pipe(
      retryStrategy(3, 2000),
      catchError((error) => throwError(() => error))
    );
  }

  let headers = new HttpHeaders({
    // 'Ocp-Apim-Subscription-Key': environment.apimSubKey,
    environment: environment.env,
    // 'current-role': environment.currentRole,
  });

  // Merge existing headers from the request
  if (req.headers?.keys().length) {
    req.headers.keys().forEach((key) => {
      const value = req.headers.get(key);
      if (value) {
        headers = headers.set(key, value);
      }
    });
  }

  if (isCsApps) {
    return from(authService.getToken()).pipe(
      switchMap((token) => {
        const cloned = req.clone({
          url: isCsApps ? req.url : `${environment.apimBaseUrl}${req.url}`,
          headers: headers.set('access_token', token!),
        });
        return next(cloned).pipe(
          retryStrategy(3, 2000),
          catchError((error) => throwError(() => error))
        );
      })
    );
  }

  const cloned = req.clone({
    url: isCsApps ? req.url : `${environment.apimBaseUrl}${req.url}`,
    headers,
  });
  return next(cloned).pipe(
    retryStrategy(3, 2000),
    catchError((error) => throwError(() => error))
  );
};
